export enum OpenAccountType {
    PRIMARY = "Primary",
    SECONDARY = "Secondary"
}

export const AccountReasonNoTinOptions = [
  { value: 'A', text: 'Reason A - The country where the Account Holder is subject to income tax as a resident does not issue TINs.' },
  { value: 'B', text: 'Reason B – The Account Holder is otherwise unable to obtain a TIN or equivalent number.' },
  { value: 'C', text: 'Reason C – No TIN is required because the tax residence jurisdiction that issued the TIN does not require a Financial Institution to collect and report the TIN.' },
];